import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-privacy-policy-page',
  imports: [],
  templateUrl: './privacy-policy-page.html',
  styleUrl: './privacy-policy-page.css'
})
export class PrivacyPolicyPage {
constructor(private router :Router){}
navigateAndScroll(route: string, x: number=0, y: number=0) {
    this.router.navigate([route]).then(() => {
      window.scrollTo(x, y);
    });
  }}


